import React, {useEffect} from 'react'
import s from './PlayAgain.module.scss'

import MainLayout from 'layouts/Main'
import SecondaryFeatures from 'components/SecondaryFeatures'
import Header from 'components/Header'
import Footer from 'components/Footer'
import TagManager from "react-gtm-module"

import Hero from 'assets/images/dogmented/play-again.jpg'


const Home = ({children}) => {
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        pagePath: '/play-again',
        pageTitle: 'PlayAgain',
      },
    });
  }, [])
  return (
    <MainLayout>
      <div className={s.PlayAgain}>
        <Header />
          <div className="hero">
            <div className={s.img}>
              <img src={Hero} alt='Kia Dogmented Reality' />  
            </div>   
            <div className={s.content}>
              <h1 className={s.title}>Let's Play Again Soon.</h1>
              <p>Robo Dog will be right here waiting like a very good boy. Don’t forget to share your experience using <strong>#RoboDog</strong>.</p>
              <div className={s.row}>
                <a href="/experience" className={s.button}>Play Again</a>  
              </div>
            </div>
          </div>
          <div className={s.featureWrapper}>
            <SecondaryFeatures />
          </div>
        <Footer />
      </div>
    </MainLayout>
  )

}

export default Home
